const ALIGN_CENTER = 'center'

const MATERAIL_ATTR = [
  {
    title: '素材（画面）',
    key: 'coverUrl',
    fixed: true,
    align: ALIGN_CENTER,
    disabled: true,
    width: 108
  },
  {
    title: '素材ID',
    key: 'imageId',
    fixed: true,
    width: 120,
    overflow: true
  },
  {
    title: '素材名称',
    key: 'imageName',
    fixed: true,
    width: 108,
    overflow: true
  },

  {
    title: '素材类型',
    key: 'type',
    width: 70
  },

  {
    title: '设计师',
    key: 'designerName',
    width: 62
  },
  {
    title: '策划师',
    key: 'plannerName',
    width: 62
  },
  {
    title: '上传时间',
    key: 'uploadTime',
    width: 72
  },
  {
    title: '消耗起始时间',
    key: 'lauchTime',
    width: 72
  },
  {
    title: '素材样式',
    key: 'imageStyle2LabelNames',
    overflow: true,
    width: 120
  },

  {
    title: 'AI标签',
    key: 'aiLabelNames',
    overflow: true,
    width: 70
  },

  {
    title: '3D视频源',
    key: 'videoLabelNames',
    overflow: true,
    width: 80
  },

  {
    title: '素材绑定游戏',
    key: 'gameNames',
    overflow: true,
    width: 70
  },
  {
    title: '素材板式',
    key: 'imageOrientation',
    width: 70
  },
  {
    title: '备注',
    key: 'remark',
    overflow: true,
    width: 160
  }
].map((i) => ({ ...i, checked: true }))

const BASIC_DATA = [
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '关联计划数',
    key: 'relatedPlanCount',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '有消耗计划数',
    key: 'hasAmountCount',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '曝光量',
    key: 'pv',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '千次曝光成本',
    key: 'pvCostPerThousand',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '点击量',
    key: 'clickNum',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '点击成本',
    key: 'clickUnitPrice',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '点击率',
    key: 'clickRate',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 76
  },
  {
    title: '7日消耗',
    key: 'amount7',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 76
  },
  {
    title: '30日消耗',
    key: 'thirtyDayAmount',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 80
  },
  {
    title: '激活数',
    key: 'downNum',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 72
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 72
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '新创角付费数',
    key: 'payRoleUserNum',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 108
  },
  {
    title: '新创角付费次数',
    key: 'newRolePayCnt',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 108
  },
  {
    title: '新创角付费成本',
    key: 'newPayCost',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 108
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 108
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 124
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 114
  },
  {
    title: '创角账号24H付费金额',
    key: 'createRole24hPayMoney',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  }
].map((i) => ({ ...i, checked: true }))

const LTV_ROI_RETAIN_DATA = [
  {
    title: '创角账号24HROI',
    key: 'createRole24hRoi',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98,
    checked: false
  },
  {
    title: '创角账号1日ROI',
    key: 'createRoleRoi1d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号2日ROI',
    key: 'createRoleRoi2d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号3日ROI',
    key: 'createRoleRoi3d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号4日ROI',
    key: 'createRoleRoi4d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号5日ROI',
    key: 'createRoleRoi5d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号6日ROI',
    key: 'createRoleRoi6d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号7日ROI',
    key: 'createRoleRoi7d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号10日ROI',
    key: 'createRoleRoi10d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号15日ROI',
    key: 'createRoleRoi15d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号30日ROI',
    key: 'createRoleRoi30d',
    sortable: 'custom',
    align: ALIGN_CENTER,
    width: 98
  },
  {
    title: '创角账号1日LTV',
    key: 'createRoleOneDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号2日LTV',
    key: 'createRoleTwoDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号3日LTV',
    key: 'createRoleThreeDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号4日LTV',
    key: 'createRoleFourDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号5日LTV',
    key: 'createRoleFiveDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号6日LTV',
    key: 'createRoleSixDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号7日LTV',
    key: 'createRoleSevenDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号15日LTV',
    key: 'createRoleFifteenDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号30日LTV',
    key: 'createRoleThirtyDayLtv',
    align: ALIGN_CENTER,
    width: 78
  },
  {
    title: '创角账号2日留存',
    key: 'createRoleTwoDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号3日留存',
    key: 'createRoleThreeDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号4日留存',
    key: 'createRoleFourDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号5日留存',
    key: 'createRoleFiveDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号6日留存',
    key: 'createRoleSixDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号7日留存',
    key: 'createRoleSevenDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号10日留存',
    key: 'createRoleTenDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号15日留存',
    key: 'createRoleFifteenDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号30日留存',
    key: 'createRoleThirtyDayRetainRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '创角账号次日付费留存',
    key: 'twoDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号3日付费留存',
    key: 'threeDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号4日付费留存',
    key: 'fourDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号5日付费留存',
    key: 'fiveDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号6日付费留存',
    key: 'sixDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号7日付费留存',
    key: 'sevenDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号10日付费留存',
    key: 'tenDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号15日付费留存',
    key: 'fifteenDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号30日付费留存',
    key: 'thirtyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 82
  },
  {
    title: '创角账号60日付费留存',
    key: 'sixtyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号90日付费留存',
    key: 'ninetyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号120日付费留存',
    key: 'oneHundredAndTwentyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号150日付费留存',
    key: 'oneHundredAndFiftyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号180日付费留存',
    key: 'oneHundredAndEightyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号210日付费留存',
    key: 'twoHundredAndTenDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号240日付费留存',
    key: 'twoHundredAndFortyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号270日付费留存',
    key: 'twoHundredAndSeventyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号300日付费留存',
    key: 'threeHundredDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号330日付费留存',
    key: 'threeHundredAndThirtyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  },
  {
    title: '创角账号360日付费留存',
    key: 'threeHundredAndSixtyDayNewPayRoleRetain',
    align: ALIGN_CENTER,
    width: 92
  }
].map((i) => ({ ...i, checked: i.checked !== false }))

const VIDEO_PLAY_DATA = [
  {
    title: '播放数',
    key: 'totalPlay',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '有效播放数',
    key: 'validPlay',
    align: ALIGN_CENTER,
    width: 72
  },
  {
    title: '有效播放率',
    key: 'validPlayRate',
    align: ALIGN_CENTER,
    width: 72
  },
  {
    title: '播放完成数',
    key: 'playOver',
    align: ALIGN_CENTER,
    width: 72
  },
  {
    title: '播完率',
    key: 'playOverRate',
    align: ALIGN_CENTER,
    width: 58
  },
  {
    title: '3s播放率',
    key: 'playDuration3sRate',
    align: ALIGN_CENTER,
    width: 66
  },
  {
    title: '25%进度播放率',
    key: 'play25FeedBreakRate',
    align: ALIGN_CENTER,
    width: 96
  },
  {
    title: '50%进度播放率',
    key: 'play50FeedBreakRate',
    align: ALIGN_CENTER,
    width: 96
  },
  {
    title: '75%进度播放率',
    key: 'play75FeedBreakRate',
    align: ALIGN_CENTER,
    width: 96
  },
  {
    title: '平均单次播放时长(头条)',
    key: 'averagePlayTimePerPlay',
    align: ALIGN_CENTER,
    width: 106
  },
  {
    title: '平均单次有效播放时长(腾讯)',
    key: 'averageValidPlayTimePerPlay',
    align: ALIGN_CENTER,
    width: 106
  },
  {
    title: '分享数',
    key: 'videoShare',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '评论数',
    key: 'videoComment',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '点赞数',
    key: 'videoLike',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '不感兴趣数',
    key: 'dislike',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '新增关注数',
    key: 'follow',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '私信数',
    key: 'messageAction',
    align: ALIGN_CENTER,
    width: 88
  },
  {
    title: '举报数',
    key: 'report',
    align: ALIGN_CENTER,
    width: 88
  }
].map((i) => ({ ...i, checked: i.checked !== false }))

export default {
  MATERAIL_ATTR,
  BASIC_DATA,
  LTV_ROI_RETAIN_DATA,
  VIDEO_PLAY_DATA
}
export const NAVS = [
  {
    label: '计划指标',
    key: 'ad',
    children: [
      {
        label: '素材属性',
        key: 'MATERAIL_ATTR'
      },

      {
        label: '基础数据',
        key: 'BASIC_DATA'
      },
      {
        label: 'LTV/ROI/留存数据',
        key: 'LTV_ROI_RETAIN_DATA'
      },
      {
        label: '播放数据',
        key: 'VIDEO_PLAY_DATA'
      }
    ]
  }
]
